import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { _ as _to_consumable_array } from "@swc/helpers/_/_to_consumable_array";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState, useEffect } from "react";
import { Link, NavLink, useParams } from "react-router-dom";
import DataTable from "react-data-table-component";
import Form from "react-bootstrap/Form";
import { utils, writeFileXLSX } from "xlsx";
import Select from "react-select";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { Formik } from "formik";
import * as yup from "yup";
import DatePicker from "react-datepicker";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import "react-datepicker/dist/react-datepicker.css";
import DataTableLayout from "layouts/DatatableLayout";
import DownloadExcel from "utils/DownloadExcel";
import { getAllMstOfficeSection } from "../../redux/handlers/master/getAllMstOfficeSection.handler";
import { useAppDispatch, useAppSelector } from "../../redux/store/configureStore";
import { mapMstToOptions } from "utils/HelperFunction";
import { defaultOption } from "constants/ui/options";
import { useGlobalLoaderContext } from "contexts/GlobalLoaderContext";
import { getAllNewAlldernowEmp } from "../../redux/handlers/logic/getAllNewAlldernowEmp.handler";
import { useGlobalModalContext } from "contexts/GlobalModalContext";
import { useGlobalSelectedBranchContext } from "contexts/GlobalSelectedBranchContext";
import { getFullUrlPath } from "utils/HandleFileFunction";
import { getAllMstPosition } from "../../redux/handlers/master/getAllMstPosition.handler";
import { getAllMstDepartment } from "../../redux/handlers/master/getAllMstDepartment.handler";
import { getAllMstNewAlldernowRole } from "../../redux/handlers/master/getAllMstNewAlldernowRole.handler";
import { getNewAlldernowEmpById } from "../../redux/handlers/logic/getNewAlldernowEmpById.handler";
import { initialState } from "mocks/verifyRoleData";
import { getAllWarehouse } from "../../redux/handlers/master/getAllWarehouse.handler";
import axios from "axios";
import { createVerifyRoleLog } from "../../redux/handlers/auth/createVerifyRoleLog.handler";
export function EmpPermission() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useGlobalSelectedBranchContext = useGlobalSelectedBranchContext(), selectedBranchId = _useGlobalSelectedBranchContext.selectedBranchId, setSelectedBranchId = _useGlobalSelectedBranchContext.setSelectedBranchId;
    var _useState = _sliced_to_array(useState([]), 2), empActiveData = _useState[0], setEmpActiveData = _useState[1];
    var _useState1 = _sliced_to_array(useState([]), 2), empdata = _useState1[0], setEmpdata = _useState1[1];
    var _useState2 = _sliced_to_array(useState([]), 2), empAllUserdata = _useState2[0], setEmpAllUserdata = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), empUserdata = _useState3[0], setEmpUserdata = _useState3[1];
    var _useState4 = _sliced_to_array(useState([]), 2), empUserCanceldata = _useState4[0], setEmpUserCanceldata = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), empCanceldata = _useState5[0], setEmpCanceldata = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), empAlldata = _useState6[0], setEmpAlldata = _useState6[1];
    // const [optionsPosition, setOptionsPosition] = useState([]);
    // const [optionsDepartment, setOptionsDepartment] = useState([]);
    var _useState7 = _sliced_to_array(useState([]), 2), optionsMstDepartment = _useState7[0], setOptionsMstDepartment = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), optionsMstPosition = _useState8[0], setOptionsMstPosition = _useState8[1];
    var _useState9 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), position = _useState9[0], setPosition = _useState9[1];
    var _useState10 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), department = _useState10[0], setDepartment = _useState10[1];
    var getAllNewAlldernowEmpReducer = useAppSelector(function(state) {
        return state.getAllNewAlldernowEmpReducer;
    });
    var getAllMstDepartmentReducer = useAppSelector(function(state) {
        return state.getAllMstDepartmentReducer;
    });
    var getAllMstPositionReducer = useAppSelector(function(state) {
        return state.getAllMstPositionReducer;
    });
    var getempData = function() {
        dispatch(getAllNewAlldernowEmp({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    var loadAllMstOptions = function() {
        dispatch(getAllMstDepartment());
        dispatch(getAllMstPosition());
    };
    useEffect(function() {
        getempData();
        loadAllMstOptions();
    }, []);
    useEffect(function() {
        setIsLoading(getAllNewAlldernowEmpReducer.isFetching || getAllMstDepartmentReducer.isFetching || getAllMstPositionReducer.isFetching);
        if (getAllNewAlldernowEmpReducer.data) {
            var result = getAllNewAlldernowEmpReducer.data.data;
            // setEmpAlldata(result);
            // const empCancel = result.filter(
            //   (emp) => emp.end_date !== null && emp.dim_branch_id === selectedBranchId
            // );
            // const empActive = result.filter(
            //   (emp) => emp.end_date === null && emp.dim_branch_id === selectedBranchId
            // );
            // setEmpdata(empActive);
            // setEmpCanceldata(empCancel);
            var empAllUser = result.filter(function(emp) {
                return emp.end_date === null && emp.dim_branch_id === selectedBranchId && emp.dimNewAlldernowUser !== null;
            });
            var empUserCancel = result.filter(function(emp) {
                return emp.end_date !== null && emp.dim_branch_id === selectedBranchId && emp.dimNewAlldernowUser !== null;
            });
            /* const empUserActive = result.filter(
        (emp) => emp.end_date === null && emp.dim_branch_id === selectedBranchId && emp.dimNewAlldernowUser !== null
      ); */ // setEmpUserdata(empUserActive);
            setEmpAllUserdata(empAllUser);
            setEmpUserCanceldata(empUserCancel);
        }
        if (getAllMstDepartmentReducer.data) {
            var options = mapMstToOptions(getAllMstDepartmentReducer.data.data);
            setOptionsMstDepartment([
                defaultOption
            ].concat(_to_consumable_array(options)));
        }
        if (getAllMstPositionReducer.data) {
            var options1 = mapMstToOptions(getAllMstPositionReducer.data.data);
            setOptionsMstPosition([
                defaultOption
            ].concat(_to_consumable_array(options1)));
        }
    }, [
        getAllNewAlldernowEmpReducer,
        getAllMstDepartmentReducer,
        getAllMstPositionReducer
    ]);
    var columns = [
        {
            name: "รหัสพนักงาน",
            selector: function(row) {
                return row.emp_code;
            },
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/emp/permission/edit/" + row.id,
                        children: row.emp_code
                    })
                });
            }
        },
        {
            name: "รูปพนักงาน",
            selector: function(row) {
                return row.empImage;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx("img", {
                        src: row.img_path ? getFullUrlPath(row.img_path) : "",
                        className: "imgprofile"
                    })
                });
            },
            center: "true"
        },
        {
            name: "ชื่อพนักงาน (ชื่อเล่น)",
            selector: function(row) {
                return row.empName;
            },
            cell: function(row, index, column, id) /*#__PURE__*/ {
                var _row_dimMstPrefix;
                var _row_nick_name;
                return _jsxs("div", {
                    children: [
                        (_row_dimMstPrefix = row.dimMstPrefix) === null || _row_dimMstPrefix === void 0 ? void 0 : _row_dimMstPrefix.name,
                        " ",
                        row.first_name_th,
                        " ",
                        row.last_name_th,
                        " (",
                        " ",
                        (_row_nick_name = row.nick_name) !== null && _row_nick_name !== void 0 ? _row_nick_name : "-",
                        " )"
                    ]
                });
            }
        },
        {
            name: "แผนก",
            selector: function(row) {
                return row.dimMstDepartment ? row.dimMstDepartment.name : "-";
            }
        },
        {
            name: "ตำแหน่ง",
            selector: function(row) {
                return row.dimMstPosition;
            },
            cell: function(row, index, column, id) {
                return row.dimMstPosition && row.dimMstPosition.name == "เจ้าของธุรกิจ" ? /*#__PURE__*/ _jsx("div", {
                    className: "py-1 px-3",
                    style: {
                        color: "#565DFF",
                        background: "#EEF4FF",
                        borderRadius: "8px"
                    },
                    children: row.name
                }) : /*#__PURE__*/ _jsx("div", {
                    className: "ps-3",
                    children: row.dimMstPosition ? row.dimMstPosition.name : "-"
                });
            }
        },
        {
            name: "สิทธิ์การใช้งาน",
            selector: function(row) {
                return row.permissionName;
            },
            cell: function(row, index, column, id) {
                var _row_dimNewAlldernowUser_dimMstNewAlldernowRole;
                return /*#__PURE__*/ _jsx("div", {
                    className: "",
                    style: {
                        color: "#565DFF",
                        borderRadius: "8px"
                    },
                    children: (_row_dimNewAlldernowUser_dimMstNewAlldernowRole = row.dimNewAlldernowUser.dimMstNewAlldernowRole) === null || _row_dimNewAlldernowUser_dimMstNewAlldernowRole === void 0 ? void 0 : _row_dimNewAlldernowUser_dimMstNewAlldernowRole.name
                });
            }
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.id;
            },
            center: "true",
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: "btn btn-edit-st-1 me-2",
                        to: "/emp/permission/edit/" + row.id
                    })
                });
            }
        }
    ];
    var _useState11 = _sliced_to_array(useState(""), 2), filterText = _useState11[0], setFilterText = _useState11[1];
    var filteredItems = empAllUserdata.filter(function(item) {
        return item.emp_code && item.emp_code.toLowerCase().includes(filterText.toLowerCase()) || item.first_name_th && item.first_name_th.toLowerCase().includes(filterText.toLowerCase()) || item.last_name && item.last_name.toLowerCase().includes(filterText.toLowerCase()) || item.nick_name && item.nick_name.toLowerCase().includes(filterText.toLowerCase());
    });
    if (department.value != "") {
        filteredItems = filteredItems.filter(function(item) {
            return item.dim_mst_department_id == department.value;
        });
    }
    if (position.value != "") {
        filteredItems = filteredItems.filter(function(item) {
            return item.dim_mst_position_id == position.value;
        });
    }
    var _useState12 = _sliced_to_array(useState(1), 2), btnempstatus = _useState12[0], setBtnempstatus = _useState12[1];
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx("nav", {
                        "aria-label": "breadcrumb",
                        className: "mt-2 mb-5",
                        children: /*#__PURE__*/ _jsxs("ol", {
                            className: "breadcrumb fs-16 ps-0",
                            children: [
                                /*#__PURE__*/ _jsx("li", {
                                    className: "breadcrumb-item ",
                                    children: /*#__PURE__*/ _jsx("a", {
                                        href: "#",
                                        className: "tc-7  text-decoration-none",
                                        children: "บุคคล"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("li", {
                                    className: "breadcrumb-item active tc-1 ",
                                    "aria-current": "page",
                                    children: [
                                        " ",
                                        "กำหนดสิทธิ์ผู้ใช้งาน",
                                        " "
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "mb-3",
                        children: [
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 1 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(1);
                                    // setEmpdata(empAlldata);
                                    setEmpUserdata(empAllUserdata);
                                },
                                children: [
                                    "พนักงานทั้งหมด (",
                                    /*#__PURE__*/ _jsx("span", {
                                        children: empAllUserdata.length
                                    }),
                                    ")"
                                ]
                            }),
                            /*#__PURE__*/ _jsxs(Button, {
                                type: "button",
                                className: btnempstatus == 0 ? "btn-category px-4 active" : "btn-category px-4",
                                onClick: function() {
                                    setBtnempstatus(0);
                                    // setEmpdata(empCanceldata);
                                    setEmpUserdata(empUserCanceldata);
                                },
                                children: [
                                    "พนักงานที่ลาออก (",
                                    /*#__PURE__*/ _jsx("span", {
                                        children: empUserCanceldata.length
                                    }),
                                    ")",
                                    " "
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 py-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-4",
                            children: [
                                /*#__PURE__*/ _jsx(DownloadExcel, {
                                    data: filteredItems,
                                    filename: "สิทธิ์ผู้ใช้งาน"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2 me-3",
                                    style: {
                                        width: "140px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "form-st-3 sm pb-1",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "แผนก"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setDepartment(e);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsMstDepartment,
                                                placeholder: "เลือกแผนก",
                                                value: department
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mb-2  me-3",
                                    style: {
                                        width: "140px"
                                    },
                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                        className: "mb-2 form-st-3 sm pb-1 ",
                                        children: [
                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                className: "mb-1",
                                                children: "ตำแหน่ง"
                                            }),
                                            /*#__PURE__*/ _jsx(Select, {
                                                as: "select",
                                                name: "",
                                                onChange: function(e) {
                                                    setPosition(e);
                                                },
                                                className: "w-100 select-st-1",
                                                options: optionsMstPosition,
                                                placeholder: "เลือกตำแหน่ง",
                                                value: position
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาชื่อ, นามสกุล, ชื่อเล่น, รหัสพนักงาน",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Link, {
                                    to: "/emp/permission/create",
                                    className: "btn btn btn-st-7 text-decoration-none",
                                    children: "เพิ่มสิทธิ์ผู้ใช้งาน"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: true,
                            PerPage: 10
                        })
                    ]
                })
            })
        ]
    });
}
var getbranchData = function() {
    var options = [];
    fetch("/json/branch.json").then(function(response) {
        return response.json();
    }).then(function(result) {
        for(var i = 0; i < result.length; i++){
            var obj = {};
            obj["value"] = result[i].branchID;
            obj["label"] = result[i].branchName;
            options.push(obj);
        }
    }).catch(function(error) {
        return console.log("error", error);
    });
    return options;
};
var getpermissionData = function() {
    var options = [];
    fetch("/json/permission.json").then(function(response) {
        return response.json();
    }).then(function(result) {
        for(var i = 0; i < result.length; i++){
            var obj = {};
            obj["value"] = result[i].permissionID;
            obj["label"] = result[i].permissionName;
            options.push(obj);
        }
    }).catch(function(error) {
        return console.log("error", error);
    });
    return options;
};
/* const getEditData = (productID) => {
  return fetch("/json/permission2.json")
    .then((response) => response.json())
    .then((result) => {
      return result;
    })
    .catch((error) => console.log("error", error));
}; */ var getdepartmentData = function() {
    var empty = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var options = [];
    fetch("/json/department.json").then(function(response) {
        return response.json();
    }).then(function(result) {
        if (empty === true) {
            var obj = {};
            obj["value"] = "";
            obj["label"] = "ทั้งหมด";
            options.push(obj);
        }
        for(var i = 0; i < result.length; i++){
            var obj = {};
            obj["value"] = result[i].departmentID;
            obj["label"] = result[i].departmentName;
            options.push(obj);
        }
    }).catch(function(error) {
        return console.log("error", error);
    });
    return options;
};
export function EmpManagePermission() {
    var dispatch = useAppDispatch();
    var _useGlobalModalContext = useGlobalModalContext(), modalObj = _useGlobalModalContext.modalObj, setModalObj = _useGlobalModalContext.setModalObj;
    var _useGlobalLoaderContext = useGlobalLoaderContext(), isloading = _useGlobalLoaderContext.isloading, setIsLoading = _useGlobalLoaderContext.setIsLoading;
    var _useGlobalSelectedBranchContext = useGlobalSelectedBranchContext(), selectedBranchId = _useGlobalSelectedBranchContext.selectedBranchId, setSelectedBranchId = _useGlobalSelectedBranchContext.setSelectedBranchId;
    var permissionID = useParams().permissionID;
    var empID = useParams().empID;
    var _useState = _sliced_to_array(useState(false), 2), modalDeleteShow = _useState[0], setModalDeleteShow = _useState[1];
    var _useState1 = _sliced_to_array(useState(false), 2), modalsuccessShow = _useState1[0], setModalsuccessShow = _useState1[1];
    var _useState2 = _sliced_to_array(useState(false), 2), modalInviteShow = _useState2[0], setModalInviteShow = _useState2[1];
    var _useState3 = _sliced_to_array(useState([]), 2), optionsBranch = _useState3[0], setOptionsBranch = _useState3[1];
    /* const [optionsBranch, setOptionsBranch] = useState([
    { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
    { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
    { value: "purple", label: "Purple", color: "#5243AA" },
    { value: "red", label: "Red", color: "#FF5630", isFixed: true },
    { value: "orange", label: "Orange", color: "#FF8B00" },
    { value: "yellow", label: "Yellow", color: "#FFC400" },
    { value: "green", label: "Green", color: "#36B37E" },
    { value: "forest", label: "Forest", color: "#00875A" },
    { value: "slate", label: "Slate", color: "#253858" },
    { value: "silver", label: "Silver", color: "#666666" },
  ]); */ var _useState4 = _sliced_to_array(useState([]), 2), optionsMstNewAlldernowRole = _useState4[0], setOptionsMstNewAlldernowRole = _useState4[1];
    var _useState5 = _sliced_to_array(useState([]), 2), optionsMstOfficeSection = _useState5[0], setOptionsMstOfficeSection = _useState5[1];
    var _useState6 = _sliced_to_array(useState([]), 2), optionsCentralWarehouse = _useState6[0], setOptionsCentralWarehouse = _useState6[1];
    var _useState7 = _sliced_to_array(useState([]), 2), empdata = _useState7[0], setEmpdata = _useState7[1];
    var _useState8 = _sliced_to_array(useState([]), 2), empSelectUserdata = _useState8[0], setEmpSelectUserdata = _useState8[1];
    var _useState9 = _sliced_to_array(useState([]), 2), empActiveData = _useState9[0], setEmpActiveData = _useState9[1];
    var _useState10 = _sliced_to_array(useState([]), 2), empCanceldata = _useState10[0], setEmpCanceldata = _useState10[1];
    var _useState11 = _sliced_to_array(useState([]), 2), empAlldata = _useState11[0], setEmpAlldata = _useState11[1];
    var _useState12 = _sliced_to_array(useState([]), 2), optionsPosition = _useState12[0], setOptionsPosition = _useState12[1];
    var _useState13 = _sliced_to_array(useState([]), 2), optionsDepartment = _useState13[0], setOptionsDepartment = _useState13[1];
    var _useState14 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), position = _useState14[0], setPosition = _useState14[1];
    var _useState15 = _sliced_to_array(useState({
        value: "",
        label: "ทั้งหมด"
    }), 2), department = _useState15[0], setDepartment = _useState15[1];
    var getAllNewAlldernowEmpReducer = useAppSelector(function(state) {
        return state.getAllNewAlldernowEmpReducer;
    });
    var getempData = function() {
        dispatch(getAllNewAlldernowEmp({
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        getempData();
    // setOptionsPosition(getpositionData(true));
    // setOptionsDepartment(getdepartmentData(true));
    }, []);
    useEffect(function() {
        setIsLoading(getAllNewAlldernowEmpReducer.isFetching);
        if (getAllNewAlldernowEmpReducer.data) {
            var result = getAllNewAlldernowEmpReducer.data.data;
            setEmpAlldata(result);
            var empCancel = result.filter(function(emp) {
                return emp.end_date !== null && emp.dim_branch_id === selectedBranchId;
            });
            var empActive = result.filter(function(emp) {
                return emp.end_date === null && emp.dim_branch_id === selectedBranchId;
            });
            setEmpdata(empActive);
            setEmpActiveData(empActive);
            setEmpCanceldata(empCancel);
        }
    }, [
        getAllNewAlldernowEmpReducer
    ]);
    var schema = yup.object({
        dim_new_alldernow_emp_id: yup.string().required("กำหนดพนักงาน"),
        dim_mst_new_alldernow_role_id: yup.string().required("กรุณากำหนดสิทธิผู้ใช้งาน"),
        dim_mst_os_ids: yup.array().min(1, "กรุณาเลือกอย่างน้อยหนึ่งส่วนงาน").required("กรุณาเลือกสาขา")
    });
    var _useState16 = _sliced_to_array(useState(false), 2), formdisabled = _useState16[0], setFormdisabled = _useState16[1];
    // const [branchselected, setBranchselected] = useState([]);
    var _useState17 = _sliced_to_array(useState({}), 2), pdata = _useState17[0], setPdata = _useState17[1];
    var _useState18 = _sliced_to_array(useState(""), 2), filterText = _useState18[0], setFilterText = _useState18[1];
    var _useState19 = _sliced_to_array(useState({}), 2), selectedEmp = _useState19[0], setSelectedEmp = _useState19[1];
    var filteredItems = empActiveData.filter(function(item) {
        return item.emp_code && item.emp_code.toLowerCase().includes(filterText.toLowerCase()) || item.first_name_th && item.first_name_th.toLowerCase().includes(filterText.toLowerCase()) || item.last_name && item.last_name.toLowerCase().includes(filterText.toLowerCase()) || item.nick_name && item.nick_name.toLowerCase().includes(filterText.toLowerCase());
    });
    var getAllMstNewAlldernowRoleReducer = useAppSelector(function(state) {
        return state.getAllMstNewAlldernowRoleReducer;
    });
    var getAllMstOfficeSectionReducer = useAppSelector(function(state) {
        return state.getAllMstOfficeSectionReducer;
    });
    var getAllWarehouseReducer = useAppSelector(function(state) {
        return state.getAllWarehouseReducer;
    });
    var loadAllMstsOptions = function() {
        dispatch(getAllMstNewAlldernowRole());
        dispatch(getAllMstOfficeSection());
        var queryParams = {
            isCentralWarehouse: true
        };
        dispatch(getAllWarehouse({
            queryParams: queryParams
        }));
    };
    useEffect(function() {
        loadAllMstsOptions();
    }, []);
    useEffect(function() {
        setIsLoading(getAllMstNewAlldernowRoleReducer.isFetching || getAllMstOfficeSectionReducer.isFetching || getAllWarehouseReducer.isFetching);
        if (getAllMstNewAlldernowRoleReducer.data) {
            var options = mapMstToOptions(getAllMstNewAlldernowRoleReducer.data.data);
            setOptionsMstNewAlldernowRole(_to_consumable_array(options));
        }
        if (getAllMstOfficeSectionReducer.data) {
            var options1 = mapMstToOptions(getAllMstOfficeSectionReducer.data.data);
            setOptionsMstOfficeSection(_to_consumable_array(options1));
        }
        if (getAllWarehouseReducer.data) {
            var option = mapMstToOptions(getAllWarehouseReducer.data.data);
            setOptionsCentralWarehouse(_to_consumable_array(option));
        }
    }, [
        getAllMstNewAlldernowRoleReducer,
        getAllMstOfficeSectionReducer,
        getAllWarehouseReducer
    ]);
    var getNewAlldernowEmpByIdReducer = useAppSelector(function(state) {
        return state.getNewAlldernowEmpByIdReducer;
    });
    var loadEmpById = function(id) {
        dispatch(getNewAlldernowEmpById(id, {
            modalObj: modalObj,
            setModalObj: setModalObj
        }));
    };
    useEffect(function() {
        if (empID) {
            loadEmpById(empID);
            setFormdisabled(true);
        }
    }, [
        empID
    ]);
    useEffect(function() {
        setIsLoading(getNewAlldernowEmpByIdReducer.isFetching);
        if (empID && getNewAlldernowEmpByIdReducer.data) {
            var _empEdit_dimNewAlldernowUser;
            var empEdit = getNewAlldernowEmpByIdReducer.data.data;
            setSelectedEmp(empEdit);
            // console.log('EMP-EDIT',empEdit);
            setFormdata({
                dim_new_alldernow_emp_id: empEdit.id,
                dim_mst_new_alldernow_role_id: (_empEdit_dimNewAlldernowUser = empEdit.dimNewAlldernowUser) === null || _empEdit_dimNewAlldernowUser === void 0 ? void 0 : _empEdit_dimNewAlldernowUser.dimMstNewAlldernowRole.id
            });
        }
    }, [
        getNewAlldernowEmpByIdReducer
    ]);
    /* const handleChangeBranch = (options) => {
    let optionselect = [];
    options.map((option, index) => {
      optionselect.push(option.value);
    });
    setBranchselected(optionselect);
  }; */ var handleSearchChange = function(event) {
        setFilterText(event.target.value);
    };
    var handleOnClear = function() {};
    var handleOnFocus = function() {
        console.log("Focused");
    };
    var _useState20 = _sliced_to_array(useState(initialState), 2), formData = _useState20[0], setFormdata = _useState20[1];
    var _useState21 = _sliced_to_array(useState(false), 2), showCentralBox = _useState21[0], setCentralBox = _useState21[1];
    var createVerifyRoleLogReducer = useAppSelector(function(state) {
        return state.createVerifyRoleLogReducer;
    });
    useEffect(function() {
        setIsLoading(createVerifyRoleLogReducer.isFetching);
        if (createVerifyRoleLogReducer.data && !createVerifyRoleLogReducer.isError) {
            setFormdisabled(true);
        }
    }, [
        createVerifyRoleLogReducer
    ]);
    var formatResult = function(item) {
        var _item_dimMstPrefix;
        return /*#__PURE__*/ _jsxs("div", {
            className: "d-flex align-items-center",
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "me-2 fs-14",
                    style: {
                        display: "block",
                        color: "#565DFF"
                    },
                    children: item.emp_code
                }),
                /*#__PURE__*/ _jsxs("div", {
                    children: [
                        (_item_dimMstPrefix = item.dimMstPrefix) === null || _item_dimMstPrefix === void 0 ? void 0 : _item_dimMstPrefix.name,
                        item.first_name_th,
                        " ",
                        item.last_name_th
                    ]
                })
            ]
        }, item.empID);
    };
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("nav", {
                "aria-label": "breadcrumb",
                className: "mt-2 mb-4",
                children: /*#__PURE__*/ _jsxs("ol", {
                    className: "breadcrumb fs-16 ps-0",
                    children: [
                        /*#__PURE__*/ _jsx("li", {
                            className: "breadcrumb-item ",
                            children: /*#__PURE__*/ _jsx("a", {
                                href: "#",
                                className: "tc-7  text-decoration-none",
                                children: "บุคคล"
                            })
                        }),
                        /*#__PURE__*/ _jsxs("li", {
                            className: "breadcrumb-item active tc-1 ",
                            "aria-current": "page",
                            children: [
                                " ",
                                "กำหนดสิทธิ์ผู้ใช้งาน",
                                " "
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2 mb-4",
                children: /*#__PURE__*/ _jsx("div", {
                    className: "card-body px-xl-4 py-4",
                    children: /*#__PURE__*/ _jsx(Formik, {
                        enableReinitialize: true,
                        // initialValues={filteredItems}
                        initialValues: formData,
                        // validateOnMount={true}
                        validationSchema: schema,
                        onSubmit: function() {
                            var _ref = _async_to_generator(function(values /* , { resetForm } */ ) {
                                return _ts_generator(this, function(_state) {
                                    console.log("Form submitted with values:", values);
                                    setFormdisabled(true);
                                    setModalInviteShow(true);
                                    dispatch(createVerifyRoleLog(values, {
                                        modalObj: modalObj,
                                        setModalObj: setModalObj
                                    }));
                                    return [
                                        2
                                    ];
                                });
                            /* try {
                const response = await axios.post('http://localhost:3000/api/v1/verify-role-log', values);
                console.log('API Response:', response.data);
                alert('Invitation sent successfully!');
                // resetForm();
              } catch (error) {
                console.error('Error sending invitation:', error.response || error.message);
                alert('Failed to send invitation. Please try again.');
              } */ });
                            return function(values) {
                                return _ref.apply(this, arguments);
                            };
                        }(),
                        children: function(param) {
                            var handleSubmit = param.handleSubmit, handleChange = param.handleChange, touched = param.touched, errors = param.errors, values = param.values, setFieldValue = param.setFieldValue, isInvalid = param.isInvalid, isValid = param.isValid, dirty = param.dirty;
                            var _selectedEmp_dimNewAlldernowUser;
                            return /*#__PURE__*/ _jsxs(Form, {
                                className: " ",
                                noValidate: true,
                                onSubmit: function(e) {
                                    e.preventDefault();
                                    // setFieldValue("branch", branchselected);
                                    // setFieldValue("role", roleselected);
                                    handleSubmit();
                                },
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "d-flex align-items-center  mb-4 ",
                                        children: /*#__PURE__*/ _jsxs("div", {
                                            className: "fs-18 fw-bold me-auto",
                                            style: {
                                                color: "rgba(137, 130, 130, 1)"
                                            },
                                            children: [
                                                " ",
                                                "ดึงข้อมูลพนักงาน"
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "",
                                        children: /*#__PURE__*/ _jsx("div", {
                                            className: "row",
                                            children: /*#__PURE__*/ _jsx("div", {
                                                className: "col-xl-9 col-xxl-8",
                                                children: /*#__PURE__*/ _jsxs("fieldset", {
                                                    disabled: formdisabled,
                                                    children: [
                                                        /*#__PURE__*/ _jsx("div", {
                                                            className: "row",
                                                            children: /*#__PURE__*/ _jsx("div", {
                                                                className: "col-xl-4",
                                                                children: !empID && /*#__PURE__*/ _jsxs(Form.Group, {
                                                                    className: "mb-3 form-st-3 pb-1",
                                                                    children: [
                                                                        /*#__PURE__*/ _jsxs(Form.Label, {
                                                                            className: "mb-1",
                                                                            style: {
                                                                                zIndex: "12"
                                                                            },
                                                                            children: [
                                                                                "ค้นหาพนักงาน",
                                                                                " "
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ _jsx(ReactSearchAutocomplete, {
                                                                            items: filteredItems,
                                                                            placeholder: "ค้นหาพนักงาน",
                                                                            onSelect: function(item) {
                                                                                var _item_dimNewAlldernowUser;
                                                                                // console.log("Selected Employee:", item);
                                                                                setSelectedEmp(item);
                                                                                setFormdata({
                                                                                    dim_new_alldernow_emp_id: item.id,
                                                                                    dim_mst_new_alldernow_role_id: (_item_dimNewAlldernowUser = item.dimNewAlldernowUser) === null || _item_dimNewAlldernowUser === void 0 ? void 0 : _item_dimNewAlldernowUser.dimMstNewAlldernowRole.id
                                                                                });
                                                                                setFieldValue("dim_new_alldernow_emp_id", item.id);
                                                                            },
                                                                            onFocus: handleSearchChange,
                                                                            onClear: function() {
                                                                                return setFilterText("");
                                                                            },
                                                                            autoFocus: true,
                                                                            formatResult: formatResult,
                                                                            fuseOptions: {
                                                                                keys: [
                                                                                    "id",
                                                                                    "emp_code",
                                                                                    "first_name_th"
                                                                                ]
                                                                            },
                                                                            resultStringKeyName: "first_name_th",
                                                                            className: "scrollSearchAutocomplete",
                                                                            styling: {
                                                                                height: "54px",
                                                                                borderRadius: "10px",
                                                                                boxShadow: "none",
                                                                                zIndex: 10,
                                                                                // border: "1px solid rgb(223, 225, 229)",
                                                                                border: !values.dim_new_alldernow_emp_id ? "1px solid #dc3545" : "1px solid rgb(223, 225, 229)"
                                                                            },
                                                                            showIcon: false
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsx("hr", {
                                                            style: {
                                                                opacity: 0.1
                                                            }
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "row",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-3 form-st-3 pb-1 ",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: [
                                                                                    "รหัสพนักงาน",
                                                                                    " ",
                                                                                    /*#__PURE__*/ _jsx("span", {
                                                                                        className: "text-danger",
                                                                                        children: "*"
                                                                                    }),
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                // name="emp_code"
                                                                                className: "form-control",
                                                                                placeholder: "รหัสพนักงาน",
                                                                                value: selectedEmp.emp_code,
                                                                                onChange: handleChange,
                                                                                isInvalid: !!errors.emp_code,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 mt-3 form-st-3 pb-1  ",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "ชื่อพนักงาน"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                // name="first_name_th"
                                                                                className: "form-control",
                                                                                placeholder: "ชื่อพนักงาน",
                                                                                value: selectedEmp.first_name_th,
                                                                                onChange: handleChange,
                                                                                isInvalid: !!errors.first_name_th,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 mt-3 form-st-3 pb-1  ",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "สกุลพนักงาน"
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                // name="last_name_th"
                                                                                className: "form-control",
                                                                                placeholder: "สกุลพนักงาน",
                                                                                value: selectedEmp.last_name_th,
                                                                                onChange: handleChange,
                                                                                isInvalid: !!errors.last_name_th,
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-2 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsx(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: "E-mail "
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Form.Control, {
                                                                                type: "text",
                                                                                name: "email",
                                                                                className: "form-control",
                                                                                placeholder: "E-mail ",
                                                                                value: selectedEmp.email,
                                                                                onChange: handleChange,
                                                                                // isInvalid={!!errors.email}
                                                                                disabled: true
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ _jsx("hr", {
                                                            style: {
                                                                opacity: 0.1
                                                            }
                                                        }),
                                                        /*#__PURE__*/ _jsx("div", {
                                                            children: /*#__PURE__*/ _jsx(Form.Label, {
                                                                className: "mb-2  tc-10",
                                                                children: "สิทธิผู้ใช้งาน"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ _jsxs("div", {
                                                            className: "row",
                                                            children: [
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-3 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: [
                                                                                    "กำหนดสิทธิผู้ใช้งาน",
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                className: "w-100 select-st-1 ".concat(formdisabled ? "pointer-events-none" : "", " ").concat(values.dim_mst_new_alldernow_role_id ? "" : !!errors.dim_mst_new_alldernow_role_id ? "is-invalid" : ""),
                                                                                // className="w-100 select-st-1"
                                                                                as: "select",
                                                                                name: "dim_mst_new_alldernow_role_id",
                                                                                options: optionsMstNewAlldernowRole,
                                                                                onChange: function(e) {
                                                                                    setFieldValue("dim_mst_new_alldernow_role_id", e.value);
                                                                                },
                                                                                placeholder: "สิทธิผู้ใช้งาน",
                                                                                value: values.dim_mst_new_alldernow_role_id ? optionsMstNewAlldernowRole.find(function(option) {
                                                                                    return option.value === values.dim_mst_new_alldernow_role_id;
                                                                                }) : (selectedEmp === null || selectedEmp === void 0 ? void 0 : (_selectedEmp_dimNewAlldernowUser = selectedEmp.dimNewAlldernowUser) === null || _selectedEmp_dimNewAlldernowUser === void 0 ? void 0 : _selectedEmp_dimNewAlldernowUser.dimMstNewAlldernowRole) ? optionsMstNewAlldernowRole.find(function(option) {
                                                                                    return option.value === selectedEmp.dimNewAlldernowUser.dimMstNewAlldernowRole.id;
                                                                                }) : null,
                                                                                isDisabled: formdisabled
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4",
                                                                    children: /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-3 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: [
                                                                                    "ส่วนงาน",
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                className: "w-100 select-st-1 select-multi ".concat(formdisabled ? "pointer-events-none" : "", "\n                                  ").concat(errors.dim_mst_os_ids ? "is-invalid" : "", "\n                                "),
                                                                                /* ${
                                  values.dim_mst_os_ids
                                    ? ""
                                    : !!errors.dim_mst_os_ids
                                    ? "is-invalid"
                                    : ""
                                } */ name: "dim_mst_os_ids",
                                                                                as: "select",
                                                                                isMulti: true,
                                                                                options: optionsMstOfficeSection,
                                                                                onChange: function(e) {
                                                                                    setFieldValue("dim_mst_os_ids", e);
                                                                                    var isCentralSelected = e.some(function(option) {
                                                                                        return option.value === 7;
                                                                                    });
                                                                                    setCentralBox(isCentralSelected);
                                                                                },
                                                                                placeholder: "เลือกสาขา",
                                                                                value: values.dim_mst_os_ids,
                                                                                isDisabled: formdisabled
                                                                            })
                                                                        ]
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ _jsx("div", {
                                                                    className: "col-xl-4",
                                                                    children: showCentralBox && /*#__PURE__*/ _jsxs(Form.Group, {
                                                                        className: "mb-3 form-st-3 pb-1",
                                                                        children: [
                                                                            /*#__PURE__*/ _jsxs(Form.Label, {
                                                                                className: "mb-1",
                                                                                children: [
                                                                                    "เลือกคลังกลาง",
                                                                                    " "
                                                                                ]
                                                                            }),
                                                                            /*#__PURE__*/ _jsx(Select, {
                                                                                className: "w-100 select-st-1 select-multi",
                                                                                name: "dim_warehouse_ids",
                                                                                as: "select",
                                                                                isMulti: true,
                                                                                options: optionsCentralWarehouse,
                                                                                onChange: function(e) {
                                                                                    setFieldValue("dim_warehouse_ids", e);
                                                                                },
                                                                                placeholder: "เลือกคลังกลาง",
                                                                                value: values.dim_warehouse_ids,
                                                                                isDisabled: formdisabled
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "text-end pb-4 pt-4 pe-3",
                                        children: formdisabled === true ? /*#__PURE__*/ _jsx(Button, {
                                            type: "button",
                                            className: "btn-st-3 mx-3",
                                            onClick: function(e) {
                                                setFormdisabled(false);
                                            },
                                            children: "แก้ไข"
                                        }) : /*#__PURE__*/ _jsxs("div", {
                                            className: " pt-3 d-flex btn-group-control w-100",
                                            children: [
                                                empID /* permissionID */  ? /*#__PURE__*/ _jsx(Button, {
                                                    type: "button",
                                                    className: "btn-st-5 me-auto ",
                                                    style: {
                                                        width: "160px"
                                                    },
                                                    onClick: function() {
                                                        return setModalDeleteShow(true);
                                                    },
                                                    children: "ลบสิทธิ์การใช้งาน"
                                                }) : /*#__PURE__*/ _jsx("div", {
                                                    className: "me-auto"
                                                }),
                                                /*#__PURE__*/ _jsx(Link, {
                                                    to: "/emp/permission",
                                                    className: "btn-st-6 me-3 btn text-decoration-none ",
                                                    children: "ยกเลิก"
                                                }),
                                                /*#__PURE__*/ _jsx(Button, {
                                                    type: "submit",
                                                    className: "btn-st-3 ",
                                                    children: "ส่งคำเชิญ"
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ _jsx(ConfirmDeleteModal, {
                                        show: modalDeleteShow,
                                        onHide: function() {
                                            return setModalDeleteShow(false);
                                        },
                                        onConfirm: function() {
                                            return setModalDeleteShow(false);
                                        },
                                        onSuccess: function() {
                                            return setModalsuccessShow(true);
                                        },
                                        pdata: pdata
                                    }),
                                    /*#__PURE__*/ _jsx(SuccessDeleteModal, {
                                        show: modalsuccessShow,
                                        onHide: function() {
                                            return setModalsuccessShow(false);
                                        }
                                    }),
                                    /*#__PURE__*/ _jsx(SendInviteSuccessModal, {
                                        show: modalInviteShow,
                                        onHide: function() {
                                            return setModalInviteShow(false);
                                        },
                                        onConfirm: function() {
                                            return setModalInviteShow(false);
                                        },
                                        // pdata={pdata}
                                        pdata: selectedEmp
                                    })
                                ]
                            });
                        }
                    })
                })
            })
        ]
    });
}
function SendInviteSuccessModal(props) {
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "md",
        centered: true,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "px-3 py-5",
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center mb-4",
                                    children: /*#__PURE__*/ _jsx("div", {
                                        className: "mx-auto icon-success"
                                    })
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text-center fs-18 tc-1 fw-bold mb-2",
                                    children: [
                                        "ระบบได้ส่งคำเชิญไปยัง",
                                        " "
                                    ]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    className: "text-center fs-18 tc-1 fw-bold mb-2",
                                    children: [
                                        "E-mail :",
                                        " ",
                                        /*#__PURE__*/ _jsx("span", {
                                            style: {
                                                color: "rgba(86, 93, 255, 1)"
                                            },
                                            children: props.pdata.email
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-18 tc-1 fw-bold",
                                    children: "เรียบร้อยแล้ว"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx("div", {
                            className: "text-center pt-4 mt-3  btn-group-control",
                            children: /*#__PURE__*/ _jsx(Button, {
                                type: "button",
                                className: "btn-st-3 mx-3 ",
                                onClick: function() {
                                    return props.onHide();
                                },
                                style: {
                                    width: "140px"
                                },
                                children: "เสร็จสิ้น"
                            })
                        })
                    ]
                })
            })
        })
    }));
}
function ConfirmDeleteModal(props) {
    var handleDelete = function(permissionID) {
        props.onHide();
        props.onSuccess();
    };
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "md",
        centered: true,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsx("div", {
                className: "px-3 py-4",
                children: /*#__PURE__*/ _jsxs("div", {
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            children: [
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-22 tc-7 mb-2",
                                    children: "คุณต้องการลบ"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "text-center fs-22 tc-7",
                                    children: "สิทธิผู้ใช้งานนี้ใช่หรือไม่"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsxs("div", {
                            className: "text-center pt-4 mt-3  btn-group-control",
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-3 mx-3  ",
                                    style: {
                                        width: "100px"
                                    },
                                    onClick: function() {
                                        return handleDelete(props.pdata.permissionID);
                                    },
                                    children: "ใช่"
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    type: "button",
                                    className: "btn-st-6 mx-3 ",
                                    style: {
                                        width: "100px"
                                    },
                                    onClick: props.onHide,
                                    children: "ไม่ใช่"
                                })
                            ]
                        })
                    ]
                })
            })
        })
    }));
}
function SuccessDeleteModal(props) {
    return /*#__PURE__*/ _jsx(Modal, _object_spread_props(_object_spread({}, props), {
        size: "sm",
        centered: true,
        children: /*#__PURE__*/ _jsx(Modal.Body, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: "px-3 py-4",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center mb-4",
                        children: /*#__PURE__*/ _jsxs("svg", {
                            width: "84",
                            height: "83",
                            viewBox: "0 0 84 83",
                            fill: "none",
                            xmlns: "http://www.w3.org/2000/svg",
                            children: [
                                /*#__PURE__*/ _jsx("circle", {
                                    cx: "42",
                                    cy: "41.5",
                                    r: "41.5",
                                    fill: "#2DC76D"
                                }),
                                /*#__PURE__*/ _jsx("path", {
                                    d: "M56.0123 30.9902L36.7444 50.2581L27.9863 41.5",
                                    stroke: "white",
                                    strokeWidth: "5",
                                    strokeLinecap: "round",
                                    strokeLinejoin: "round"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: "text-center fs-22 tc-7",
                        children: "ลบรายการสำเร็จ"
                    })
                ]
            })
        })
    }));
}
export function Permission() {
    var _useState = _sliced_to_array(useState([]), 2), data = _useState[0], setData = _useState[1];
    var getpermission = function() {
        fetch("/json/permission4.json").then(function(response) {
            return response.json();
        }).then(function(result) {
            setData(result);
        }).catch(function(error) {
            return console.log("error", error);
        });
    };
    useEffect(function() {
        getpermission();
    }, []);
    var columns = [
        {
            name: "รหัสสิทธิ์",
            selector: function(row) {
                return row.permissionCode;
            },
            width: "150px",
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    style: {
                        color: "#565DFF",
                        fontWeight: 500
                    },
                    children: /*#__PURE__*/ _jsx(Link, {
                        className: " me-2",
                        to: "/emp/permission/edit/" + row.permissionID,
                        children: row.permissionCode
                    })
                });
            }
        },
        {
            name: "ชื่อสิทธิการใช้งาน",
            selector: function(row) {
                return row.permissionName;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsxs("div", {
                    children: [
                        row.permissionName,
                        " "
                    ]
                });
            },
            width: "250px"
        },
        {
            name: "จำนวนการใช้งานสิทธิ์",
            selector: function(row) {
                return row.permissionUsage;
            },
            center: "true",
            width: "250px"
        },
        {
            name: "สถานะ",
            selector: function(row) {
                return row.status;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {
                    children: row.status == 1 ? "เปิดการใช้งาน" : "ปิดการใช้งาน"
                });
            },
            center: "true",
            width: "250px"
        },
        {
            name: "จัดการ",
            selector: function(row) {
                return row.permissionID;
            },
            cell: function(row, index, column, id) {
                return /*#__PURE__*/ _jsx("div", {});
            }
        }
    ];
    var _useState1 = _sliced_to_array(useState(""), 2), filterText = _useState1[0], setFilterText = _useState1[1];
    var filteredItems = data.filter(function(item) {
        return item.permissionName && item.permissionName.toLowerCase().includes(filterText.toLowerCase());
    });
    return /*#__PURE__*/ _jsxs("div", {
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: /*#__PURE__*/ _jsx("nav", {
                    "aria-label": "breadcrumb",
                    className: "mt-2 mb-4",
                    children: /*#__PURE__*/ _jsxs("ol", {
                        className: "breadcrumb fs-16 ps-0",
                        children: [
                            /*#__PURE__*/ _jsx("li", {
                                className: "breadcrumb-item ",
                                children: /*#__PURE__*/ _jsx("a", {
                                    href: "#",
                                    className: "tc-7  text-decoration-none",
                                    children: "บุคคล"
                                })
                            }),
                            /*#__PURE__*/ _jsxs("li", {
                                className: "breadcrumb-item active tc-1 ",
                                "aria-current": "page",
                                children: [
                                    " ",
                                    "กำหนดสิทธิ์ผู้ใช้งาน",
                                    " "
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "card card-st-2",
                children: /*#__PURE__*/ _jsxs("div", {
                    className: "card-body px-0 py-4",
                    children: [
                        /*#__PURE__*/ _jsxs("div", {
                            className: "d-flex align-items-center px-4 mb-4",
                            children: [
                                /*#__PURE__*/ _jsx(DownloadExcel, {
                                    data: filteredItems,
                                    filename: "สิทธิ์ผู้ใช้งาน"
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "me-3",
                                    children: /*#__PURE__*/ _jsx("input", {
                                        type: "text",
                                        className: "form-control form-st-4",
                                        placeholder: "ค้นหาชื่อ",
                                        onKeyUp: function(e) {
                                            return setFilterText(e.target.value);
                                        }
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Button, {
                                    to: "#",
                                    className: "btn btn btn-st-7 text-decoration-none",
                                    disabled: true,
                                    children: "เพิ่มสิทธิ์ผู้ใช้งาน"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(DataTableLayout, {
                            item: filteredItems,
                            columns: columns,
                            isSelectRows: true,
                            PerPage: 10
                        })
                    ]
                })
            })
        ]
    });
}
